import { configureStore } from "@reduxjs/toolkit";
import projectSlice from "./Slices/projectsSlice"
import theme  from "./Slices/Theme";
export const store =configureStore({
    reducer:{
        projects:projectSlice,
        Theme:theme
    },

})